import { lazy } from 'react';
import { Users } from 'lucide-react';
import type { FeatureSection } from '@/app/registry';
import { rideRoutes } from '@/features/operations/section';

/** Customers: riders, their violations, and notifications to them. Plan holders live with their plans. */
export const customersSection: FeatureSection = {
  key: 'customers',
  title: 'customers',
  icon: Users,
  routes: [
    { path: '/customers/list', title: 'customers', resource: 'customer', component: lazy(() => import('./list/CustomersPage')) },
    {
      path: '/customers/list/:customerId',
      title: 'customer',
      resource: 'customer',
      hideInMenu: true,
      component: lazy(() => import('./detail/CustomerDetailPage')),
    },
    ...rideRoutes,
    {
      path: '/customers/violations',
      title: 'violations',
      tabs: [
        { key: 'queue', title: 'reviewQueue', resource: 'area.violation', component: lazy(() => import('./violations/ViolationsPage')) },
        {
          key: 'types',
          title: 'violationTypes',
          resource: 'area.violation',
          legacyPath: '/fieldops/violation-types',
          component: lazy(() => import('@/features/fieldops/violations/ViolationTypesPage')),
        },
        { key: 'fines', title: 'violationFines', resource: 'area', component: lazy(() => import('./violations/ViolationFinesPage')) },
      ],
    },
    {
      path: '/customers/notifications',
      legacyPath: '/customers/announcements',
      title: 'announcements',
      resource: 'customer',
      component: lazy(() => import('./notifications/NotificationsPage')),
    },
  ],
};
